import { render, staticRenderFns } from "./IdentificacaoListAutorizador.vue?vue&type=template&id=6b52f48e"
import script from "./IdentificacaoListAutorizador.vue?vue&type=script&lang=js"
export * from "./IdentificacaoListAutorizador.vue?vue&type=script&lang=js"
import style0 from "./IdentificacaoListAutorizador.vue?vue&type=style&index=0&id=6b52f48e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports